'use strict';

import angular from 'angular';
import Langue from './langues.controller';

export default angular.module('aperamApp.borne.langues', [])
  .controller('LanguesController', Langue)
  .name;


// WEBPACK FOOTER //
// ./client/app/borne/langues/index.js